import { deleteRequest, getRequest, postRequest, putRequest, RequestDataType } from "services/api"
import { Customer } from "../models/customer-models"
import { Site } from "features/organizations/sites/models/sites-models"

/** Customers */
export const getAllCustomers = async () => ((await getRequest("/customers")) || []) as Customer[]

export const postNewCustomer = async (data: Partial<Customer>) => await postRequest("/customers", data, RequestDataType.Entity)

export const editCustomer = async (data: Partial<Customer>) => await putRequest("/customers", data, RequestDataType.Entity)

export const deleteCustomer = async (customerId: string) => await deleteRequest("/customers", customerId)

export const getSitesForCustomer = async (customerId: string) => ((await getRequest(`/customers/${customerId}/sites`)) || []) as Site[]
